(function () {
  const ITEMS_PER_PAGE = 6;

  const feedbackData = [
    {
  name: "Chris K.",
  date: "2025-12-17",
  rating: 5,
  title: "Protocol works great!",
  body: "At 37 years old I’ve had a lifelong struggle with growing a beard. Since I started using this system consistently I’ve begun to see some fantastic results. It’s only been about a mont but I’m genuinely pleased with the progress. I can’t wait to see how my beard grows in more.",
  verified: true,
  image: "https://cdn.shopify.com/s/files/1/0259/1821/0095/files/Review_1_7852ea3f-c909-402b-97ec-8f4bc6a370ef.jpg?v=1776601647"
},

{
  name: "Rcon89",
  date: "2024-03-16",
  rating: 5,
  title: "Instant relief",
  body: "I’ve always struggled with dry skin under my struggling beard and extremely bad dandruff. The first time I used these protocol products I immediately felt the cooling relief. After only a few days I noticed significant improvement with my dandruff issues. Using this oils paired with the beard butter my beard has never felt healthier or fuller!",
   verified: true,
  image: "https://cdn.shopify.com/s/files/1/0259/1821/0095/files/Review_4.jpg?v=1776601648"
},
    {
      name: "Nicholas C.",
      date: "2022-10-02",
      rating: 5,
      title: "My beard loves Slow Burn",
      body: "First off, my beard loves the LW blend from Honor. The oil absorbs quickly, my beard feels nice and soft styles well. Period. \nSecond, Slow Burn should be available year round! This protocol scent is great, not too strong but lasts a good long time. The different profiles come together so well to create an amazing scent that smells like sophistication in a bottle.\nAnd Lastly, Honor Initiative is a great company, creating great products and systems with a great mission.",
      verified: true
    },
{
  name: "DANIEL K.",
  date: "2024-03-17",
  rating: 5,
  title: "System that actually does what it promises",
  body: "I'm really into how this oil gets soaked up by my beard without leaving it feeling greasy. No breakouts either, which is a huge plus because other beard products just didn’t cut it for me. It's great to see my beard looking healthy and not itchy. Super happy I discovered a product/system that actually does what it promises.",
    verified: true,
  image: "https://cdn.shopify.com/s/files/1/0259/1821/0095/files/Review_2_80e54d0e-95ea-465a-ad3c-38a6280ef1ea.jpg?v=1776601648"
},
{
  name: "Rob D.",
  date: "2023-12-09",
  rating: 5,
  title: "Wish I found this years ago!",
  body: "Been growing a beard for the last few years, but I keep it on the short side and tight. Must have tried a dozen or so other balms. Most of them seemed to leave the beard too oily, too shinny, rough or had a scent that I wasn’t a fan off. This whole protocol is amazing and I wish I found this product before. Products go in super well, a little goes a long way. It does not make the beard seem shiny or oily. It makes the beard amazingly soft feeling. Love the weekly coaching too.",
  verified: true
},
{
  name: "Rex A.",
  date: "2025-08-27",
  rating: 5,
  title: "It made my beard soft and even added some volume to it.",
  body: "I've tried my fair share of beard products, but this 'protocol' really stands out. It made my beard softer, smelled great, and gave it more volume and control. Overall fantastic products and system and I'd highly recommend it to anyone, especially if you're just starting out.",
    verified: true,
  image: "https://cdn.shopify.com/s/files/1/0259/1821/0095/files/Review_3_cb101168-8243-45d1-a9e3-647af1f51849.jpg?v=1776601647"
},
{
  name: "Kaylee M.",
  date: "2025-12-12",
  rating: 5,
  title: "Perfect",
  body: "I purchased this system as a present for my husband and he absolutely loved it! He tried it immediately and noticed a huge difference. His beard is way more soft now. He also said the scent isn't too strong at all, which he liked. I definitely recommend it!",
  verified: true
},
    {
      name: "Liam S.",
      date: "2023-12-14",
      rating: 5,
      title: "Great Product",
      body: "Outstanding product that I've been using for a few years. The Hatchet and Dapper oils work well with my beard and skin, unlike others I've tried before. Honor's oils and butters make my beard soft with just the right amount of sheen. The scents are delightful and noticeable but not overpowering too.\n\nHighly recommend this. It might not suit every beard type, so try a smaller bottle first and see how it goes for you. It's been perfect for me and could be the same for you or a special man in your life.",
      verified: true
    },
    {
      name: "Nicole F.",
      date: "2022-11-14",
      rating: 5,
      title: "The best !!!",
      body: "I purchased this for the hubby and he's absolutely obsessed with this beard butter. He's so picky but was in love with this product. It makes his beard so soft and nice. It smells absolutely amazing. He plans on keeping this as a staple in his lovely routine. If you men haven't tried this product yet. He highly recommends that you do !!! One of the best beard products in the planet !!! He's living it and so will you. Can't wait to purchase more products from this awesome company. !!!",
      verified: true
    },
    {
      name: "Emily R.",
      date: "2023-12-11",
      rating: 5,
      title: "Sex in a bottle!",
      body: "I picked this up for my hubby as kind of a last-ditch effort. He's been letting his beard grow and has tried all sorts of oils and balms but honestly none of them were great. They usually had a weird smell were too strong or had no scent. But wow we both absolutely fell in love with this beard oil the moment he tried it! He's all about how it makes his beard feel soft and keeps it hydrated. And I love the sexy scent it has. It's almost like a subtle cologne but not overpowering at all!",
      verified: true
    },
    {
      name: "Rob D.",
      date: "2023-12-09",
      rating: 5,
      title: "Wish I found this years ago!",
      body: "Been growing a beard for the last few years, but I keep it on the short side and tight. Must have tried a dozen or so other balms. Most of them seemed to leave the beard too oily, too shinny, rough or had a scent that I wasn’t a fan off. This butter is amazing and I wish I found this product before. It goes in super well, a little goes a long way. It does not make the beard seem shiny or oily. It makes the beard amazingly soft feeling and man do I like the scent of this Vessel butter.",
      verified: true
    },
    {
      name: "William A.",
      date: "2021-12-23",
      rating: 5,
      title: "My new favorite brand",
      body: "So far I've tried the beard oil, butter and balm. All the products work great. Both of the two separate orders arrived quickly and without any problems. Each package came with a little vinyl sticker and personal message. All three scents (grind, dapper and vessel) smell great and last a long time without being over powering. I like that the company is small, gives back and doesn't flood me with spam. I like that the products are all natural and environmentally conscious.",
      verified: true
    },
    {
      name: "Mr. B.",
      date: "2023-10-05",
      rating: 5,
      title: "A great fall scent",
      body: "The heavy-weight Flannel Season oil is excellent. This was my first purchase from Honor and I am very pleased. Quick shipping time, a hand written thank you on the receipt, and exceptional beard oil...\n\nFlannel Season is the perfect autumn scent that gives vibes of a fall festival. It is a very pleasant scent that lasts throughout the day. May beard felt soft and nourished, and I highly recommend this product if you can get it before it sells out. \n\n-Andrew\n@mr.beardsly78",
      verified: true
    },
    {
      name: "Eric A.",
      date: "2022-11-13",
      rating: 5,
      title: "Dapper Indeed",
      body: "Dapper is a wonderfully blended smooth cologne blend that never disappoints in scent, compliment factor or feel in beard. The LW oil is more on the light to medium viscosity side and the butter is some of if not the smoothest in the game. From my experience the scent will last a good 4 to 6 hours but the nourishment and conditioning aspects from the blend used will last and feel fantastic for even longer. Great job Honor Initiative. This kit won't be my last.",
      verified: true
    },
    {
      name: "Steve S.",
      date: "2021-03-28",
      rating: 5,
      title: "Best beard oil I've found!",
      body: "I'm a fan of \"heavyweight\" beard oil. This is the best beard oil I've tried, and I've tried many oils both \"heavyweight and lightweight\". I've been using the hatchet, my family likes the smell and my wife loves it (that's the most important :wink:). Nice smell that last for hours but not to strong. Highly recommend this product. I would highly recommend for long beards such as mine. - thanks for the great product!",
      verified: true
    },
    {
      name: "Kyle L.",
      date: "2022-09-21",
      rating: 5,
      title: "Flannel season beard butter",
      body: "So I'm the kind of guy that loves anything flannel, so when honor came out with this scent I had to check it out. Another fantastic product from honor, the smell is incredible, it's masculine, it's very well balanced not over powering, but absolutely an amazing scent profile, I also bought the oil to go with it! This company is an up and Comer and giving other companies a run for their money!",
      verified: true
    },
    {
      name: "Jake T.",
      date: "2023-12-11",
      rating: 5,
      title: "A Must Have!!!",
      body: "I'm all about Honor Initiative's clay pomade for my daily style routine. It nails the matte look and gives my hair the perfect hold without any stickiness. The texture is smooth and easy to apply, though it takes a bit of extra washing out. It keeps my hair styled all day, even in humidity, and honestly, it smells fantastic. A solid choice for anyone looking for a reliable styling product!",
      verified: true
    },
    {
      name: "DANIEL K.",
      date: "2024-03-17",
      rating: 5,
      title: "Lightweight oil, not greasy",
      body: "I'm really into how this oil gets soaked up by my beard without leaving it feeling greasy. No breakouts either, which is a huge plus because other beard oils just didn't cut it for me. The scent is pretty mild and definitely not bad. It's great to see my beard looking healthy and not itchy. Super happy I discovered something that actually does what it promises.",
      verified: true
    },
    {
      name: "Ben C.",
      date: "2021-01-08",
      rating: 5,
      title: "Excellent Product",
      body: "I can’t give this product a good enough review! I’ve used lots of beard butters/oils/lotions in the past and most get clumpy and don’t leave your beard nearly as smooth as you hope. HONOR is completely different. Keeps my beard smooth, moisturized, and doesn’t leave any streaks or clumps. Highly highly recommend for anyone who is regularly outdoors during bug season!",
      verified: true
    },
    {
      name: "Nicole f.",
      date: "2022-11-14",
      rating: 5,
      title: "Fabulous!!!",
      body: "I bought this for the hubby and this is by far the best beard butter he's ever used. It's so smooth and it smells absolutely fabulous. It's made his beard so soft. It's definitely a keeper. He is real picky about what he puts on his beard and he's in love. If you men haven't tried this yet. you need it to !!! It's so good !!!!",
      verified: true
    },
    {
      name: "Herman J.",
      date: "2022-03-08",
      rating: 5,
      title: "Slow Burn is excellent!",
      body: "I just tried Honor based on what I heard on the youtube videos from Beard reviewers. So I ordered the Slow burn and it is excellent! I got the heavy weight oil because I have a gray beard and I prefer the heavier oils. This oil smells amazing and it softens my beard and makes it feel and look nice. Great product. I will be ordering other scents for sure.",
      verified: true
    },
    {
      name: "Ty T.",
      date: "2022-04-04",
      rating: 5,
      title: "I love this butter!",
      body: "This company has top notch butter and 5% goes to men's mental health. The butter has a great musk, lavender, and vanilla scent and uses the best oils for your beard (shea, coconut, avacado, grape seed, jojoba, and vitamin E). Your nose, your beard, and the ladies will thank you for using this product on your majestic chin curtain.",
      verified: true
    },
    {
      name: "Zakary G.",
      date: "2025-02-01",
      rating: 5,
      title: "Fragrance",
      body: "I’ve always had trouble with hair products that have strong fragrances, especially in the evenings. The chemicals in other products would leave me feeling uncomfortable. But this clay is different. It’s super versatile and honestly, I feel better physically in the evenings after using it, compared to all the other products I’ve tried.",
      verified: true
    },
    {
      name: "Edward S.",
      date: "2023-08-29",
      rating: 5,
      title: "Vessel!",
      body: "Really enjoy all of these butters. Consistency and effectiveness are top-notch. Typically not a fan of leather, but I wanted to try all the fragrances to see which of them I enjoyed the most. This one is fantastic! It is not your typical leather fragrance. The teakwood and bamboo add a nice complexity to this. Will be ordering again!",
      verified: true
    },
    {
      name: "Giovanni L.",
      date: "2022-12-24",
      rating: 5,
      title: "For first time person",
      body: "I received my package. When I opened the box I decided to try and use the beard oil. It smells really excellent and that smell lasted all day. I was extremely satisfied with my products I won in Decembers month giveaway. Thanks for selecting me for such amazing products. Will keep using in the future. Your awesome honor initiative.",
      verified: true
    },
    {
      name: "Foster L.",
      date: "2023-12-02",
      rating: 5,
      title: "Love the way it feels in my hair",
      body: "I don't love what it's been doing to my brushes, but that comes with the territory. My hair is super thick and voluminous and the hold of the clay is not quite there for the hold that I need, but as it grows and trains should get better. I love the way it feels in my hair, just a few weeks before it'll be perfect.",
      verified: true
    },
    {
      name: "Brett",
      date: "2020-10-02",
      rating: 5,
      title: "Great stuff!",
      body: "Everything about this beard butter is fantastic. I love that it emulsifies quickly and is easy to rub into your beard without leaving streaks or residue. It smells great - seems very natural and way better than the chemical-y stuff you get at the store. Even the packaging looks dope. I highly recommend this beard butter!",
      verified: true
    },
    {
      name: "Robert H.",
      date: "2021-10-11",
      rating: 5,
      title: "Great Kent Combs",
      body: "Oct 11, 2021\n\nHello,\n\n\n\nThe Kent 6T combs are the best.\nI haven't had these in years as the high end drug store carried another brand. \n\nThe USPS did a poor job. \nOrdered on Sept 20 and received Oct 9\nThank you for helping me with the tracking. \nI will continue to buy from you. \n\nThank you Honor !\nBob in Atlanta",
      verified: true
    },
    {
      name: "Evan H.",
      date: "2024-08-06",
      rating: 5,
      title: "Awesome Clay!",
      body: "This is the only hair product I use.\n\nI sport a mid taper with about 1.5 inches on top, spiked up in the front. This clay is perfect for giving me the volume and hold I need all day long. The scent is great, and I love that it uses organic ingredients. It doesn't get any better than this.\n\nAbsolutely love it!",
      verified: true
    },
    {
      name: "Luis G.",
      date: "2022-09-15",
      rating: 5,
      title: "No. 60 Review.",
      body: "To begin with… I was really impressed with the package. I almost felt like a gift from a family member. The scent is one of a kind. Tropical but clean, my wife loves it. The butter is amazing , I like the way it feels. Love how 10% goes to mental health. Great product , great purpose. Overall hands down 5 stars.",
      verified: true
    },
    {
      name: "Rcon89",
      date: "2021-03-16",
      rating: 5,
      title: "Instant relief",
      body: "I’ve always struggled with dry skin under my beard and extremely bad dandruff. The first time I used this oil I immediately felt the cooling relief. After only a few days I noticed significant improvement with my dandruff issues. Using this oils paired with the beard butter my beard has never felt healthier!",
      verified: true
    },
    {
      name: "Ariel A.",
      date: "2022-04-03",
      rating: 5,
      title: "Butter Masterpiece",
      body: "Truly in love with this butter!! I’ve been using it every night since I received it and not only is the scent a masterpiece but the feel in beard is on another level of perfection :100:Only regret is I wished I doubled up …hopefully it comes back!! Great job guys :pray::skin-tone-3::100::pray::skin-tone-3:",
      verified: true
    },
    {
      name: "Lee",
      date: "2022-03-10",
      rating: 5,
      title: "Best butter out there, hands down",
      body: "Ok first, the Slow Burn scent is awesome, unique and i love it... plus it lasts a long time which is great! Second, this butter is super creamy that conditions and gives a little hold but not a stiff feel. \nFact of the day: HONOR has the best butter out there.... not even close. Keep up the good work guys!",
      verified: true
    },
    {
      name: "Paul L.",
      date: "2022-04-03",
      rating: 5,
      title: "Great product but not my scent profile; Great Customer Care",
      body: "I really appreciate the prompt response from the HONOR Team. I cracked open the oil to check out the scent but it is not a scent I or my wife appreciate. I contacted HONOR and they provided me the return label for the open oil and unopened beard butter. 5 stars for a great product and great customer care.",
      verified: true
    },
    {
      name: "Larry A.",
      date: "2022-09-02",
      rating: 5,
      title: "A most Excellent set!! KUDOS!!",
      body: "Love it...the oil has a nice scent to it ( I have the Dapper). The Daily Grind Beard Butter is Excellent (especially if you enjoy the smell of Java). The short and cap are nice but the Ammo Box fits right into my Box Set (one I didn’t have) love the comb also.KUDOS on the whole set guys!! THANK YOU!!",
      verified: true
    },
    {
      name: "Brent P.",
      date: "2021-10-08",
      rating: 5,
      title: "Great Oil!",
      body: "Overall, exactly what I was looking for. A thick oil blend with a great scent. The Vanilla Sky scent is really good......smells great when first in beard and turns into a cologne type scent. Didn't expect the cologne aspect, but is very nice. Highly recommend if you are looking for a thick oil!",
      verified: true
    },
    {
      name: "Randy L.",
      date: "2022-07-16",
      rating: 5,
      title: "Hot Summer Scent",
      body: "I love all of the oils I have sampled so far and I am on my way to buy the full bottle of Vessel. It reminds me of those summer days on vacation at the beach. This will be my summer scent from now on. The functionality of these beard oils are very consistent and I appreciate the LV/HV Options.",
      verified: true
    },
    {
      name: "Bryan C.",
      date: "2021-02-24",
      rating: 5,
      title: "Superb product - the beard/lady love it!",
      body: "Love the Hatchet scent and feel, immediately received compliments from my spouse. I also have the F*ck off bugs which is great for days outdoors and keeping the bugs away. \n\nI have the wax, oil and butter and love them all - they've replaced all other product I was using for my beard!",
      verified: true
    },
    {
      name: "Lomas B.",
      date: "2021-06-14",
      rating: 5,
      title: "Fantastic",
      body: "Great high quality beard oil no complaints, the thing that separates this beard oil is the scent. If you’re like me & love peppermint don’t even hesitate especially mixed in with the tea tree. Great for the summer time especially makes your face tingle a little bit, awesome job Honor!",
      verified: true
    },
    {
      name: "Farid K.",
      date: "2023-12-17",
      rating: 5,
      title: "Works great!",
      body: "At 37 years old I've had a lifelong struggle with growing a beard. Since I started using this kit consistently I've begun to see some fantastic results. It's only been about a mont but I'm genuinely pleased with the progress. I can’t wait to see how my beard grows in.",
      verified: true
    },
    {
      name: "Chris D.",
      date: "2023-12-20",
      rating: 5,
      title: "top notch!",
      body: "I've been using HONOR beard oils for a few years now and absolutely love it! All their scents are awesome but my (and my wife's) favorite is definitely dapper. Stop using your garbage mass produced oils filled with chemicals and give Honor a try you won't be disappointed.",
      verified: true
    },
    {
      name: "Julie C.",
      date: "2022-12-16",
      rating: 5,
      title: "Borealis Bliss",
      body: "If I am being honest I read the ingredients and wanted for myself! So with the best intentions of sharing with my husband, I use it daily on my hands as a lotion/softener. Literally the best smell, non-greasy, and my fave...if you see me smelling my hands mind your business :heart_eyes:",
      verified: true
    },
    {
      name: "Lily H.",
      date: "2023-12-20",
      rating: 5,
      title: "Not just for men",
      body: "I was on the lookout for a sea salt spray that could give my hair a little TLC. I stumbled upon this gem and I'm still on my first bottle, but the results are solid. It's so good that even a friend had to get her own bottle bcause she couldn't stop borrowing mine.",
      verified: true
    },
    {
      name: "John C.",
      date: "2025-09-17",
      rating: 5,
      title: "EXCELLENT!!",
      body: "My husband and I are both hooked on this hair paste. It feels super high-quality, the ingredients are clean and safe, and it actually does what it promises. Plus, the customer service has been amazing. Fast, friendly, and really helpful. Couldn’t ask for better. Thank you!",
      verified: true
    },
    {
      name: "Sam J.",
      date: "2023-12-17",
      rating: 5,
      title: "Effective beard oil",
      body: "I've used a lot of different beard beard oils, but from now on this one is my go-to. It might be a bit pricier, but you get what you pay for. You can go for cheaper options but the results just don't compare. I highly recommend this Honor Initiative beard oil!",
      verified: true
    },
    {
      name: "Joseph B.",
      date: "2024-04-04",
      rating: 5,
      title: "The old grind, worth coming back again and again!",
      body: "Daily Grind Beard Butter is simply great! The consistency is stellar, and helps with beard “hold” without gluing my beard to my face. The Daily Grind has received numerous compliments each time I’ve used it. Thank you, Honor Initiative; great product and great scent!",
      verified: true
    },
    {
      name: "Paul J.",
      date: "2023-12-09",
      rating: 5,
      title: "Just WOW!",
      body: "I’m a leather head and this one truly does not disappoint at all. The other notes are rounded in so well and i cannot say enough about how much i love this scent. Will definitely be grabbing butter and oil as this was just a sample oil i wanted to try and WHOA!",
      verified: true
    },
    {
      name: "Mike C.",
      date: "2023-05-17",
      rating: 5,
      title: "Gentlemen’s Reserve",
      body: "First time trying out Hero Initiative. The Gentlemen’s Reserve scent profile sounded right up my alley. The heavyweight oil world great in beard. Left my beard feeling great. The scent is a winner. Strong, long lasting scent that doesn’t overpower your nose.",
      verified: true
    },
    {
      name: "Kaylee M.",
      date: "2023-12-12",
      rating: 5,
      title: "Perfect",
      body: "I purchased this as a present for my husband and he absolutely loved it! He tried it immediately and noticed a huge difference. His beard is way more soft now. He also said the scent isn't too strong at all, which he liked. I definitely recommend it!",
      verified: true
    },
    {
      name: "Josh W.",
      date: "2023-07-28",
      rating: 5,
      title: "Best customer service out there.",
      body: "Best customer service out there. I have emailed them multiple times for different reasons and always get a fast and helpful response. Their defender scent is my daily driver. I wish I could order it in bulk. Try these guys out if you haven’t already!!!",
      verified: true
    },
    {
      name: "Al",
      date: "2020-12-28",
      rating: 5,
      title: "Excellent product! Local feel",
      body: "This is the best beard I’ve used. I have tried a few different brands over the years, but Honor is the clear winner. I love that they use ingredients sourced in the USA. This butter has a very local feel to it! Highly recommend for all beard types!",
      verified: true
    },
    {
      name: "Fred K.",
      date: "2022-10-29",
      rating: 5,
      title: "3 outta 5 aint bad",
      body: "Honor Initiative is my go to now. Dapper, Vanilla Sky and vessel are very clean smelling and enjoyable. Defender is good, but can be a bit overwhelming. It will open your nostrils for sure. The Daily Grind I am not a fan of. Too sweet smelling.",
      verified: true
    },
    {
      name: "Jordan C.",
      date: "2022-10-27",
      rating: 5,
      title: "Flannel Season Does it Right",
      body: "The scent is very nice, lasts the full day, and is not overpowering, everything I expect from a beard oil. Does the trick, and causes zero issues. Will likely pick up again once I run out, assuming it becomes available after the season passes.",
      verified: true
    },
    {
      name: "Kimberly A.",
      date: "2023-12-10",
      rating: 5,
      title: "Purchase we can't live without!!",
      body: "Husband has scruff to a beard and can't LIVE without this oil! He has it in his car, at his desk, in the bathroom. Helps with dry skin under his beard. Smells AMAZING!!! Everyone in our house loves the smell. Highly, Highly, recommend!!!",
      verified: true
    },
    {
      name: "C.M",
      date: "2022-04-20",
      rating: 5,
      title: "One of the best",
      body: "I have used several different butters from other companies, but the scent with the Slow Burn is outstanding! This is my favorite scent profile. Like others here, I really do hope that this because a permanent fixture to the lineup. Great job!",
      verified: true
    },
    {
      name: "Rex A.",
      date: "2024-08-27",
      rating: 5,
      title: "It made my beard soft and even added some volume to it.",
      body: "I've tried my fair share of beard products, but this one really stands out. It made my beard softer, smelled great, and gave it more volume and control. Overall it's a fantastic product and I'd highly recommend it to anyone.",
      verified: true
    },
    {
      name: "Jorge G.",
      date: "2021-06-06",
      rating: 5,
      title: "I’m hooked!",
      body: "This is a game changer for me. I’ve never not had a bearded and the daily frustration of taming it sometime makes me want to chop it off. Enter HONOR and wow what a product. Also now my hands and face are soft and moisturized ... Bonus!",
      verified: true
    },
    {
      name: "Jamal S.",
      date: "2023-12-12",
      rating: 5,
      title: "Excellent beard balm",
      body: "This product smells amazing and goes a long way making it last. Its hands down the best beard balm Ive ever tried. Ive used Bevel before, which was good, but this one takes the cake. You can feel the difference as soon as you apply it.",
      verified: true
    },
    {
      name: "Frank P.",
      date: "2021-05-04",
      rating: 5,
      title: "Oil and Butter",
      body: "Love everything about this company. Oil and Butter feel awesome in the beard and make it soft. Everything from ordering, communicating and shipping top notch. I also really appreciate their cause. Definitely ordering my next batch soon",
      verified: true
    },
    {
      name: "Mark S.",
      date: "2021-04-09",
      rating: 5,
      title: "Fantastic!",
      body: "Love this butter! My beard has never felt softer. Most importantly, my wife likes it as well. Extremely professional and courteous company. The essential and carrier oils are on point! I love everything about this product and company!",
      verified: true
    },
    {
      name: "Austin H.",
      date: "2025-06-08",
      rating: 5,
      title: "Best matte paste",
      body: "Best matte paste I’ve tried. Other brands either had weak hold or dried my hair out. Honor's paste holds strong but keeps hair soft and easy to style all day. The scent’s light too so no complaints. Definitely my go to.",
      verified: true
    },
    {
      name: "Patrick P.",
      date: "2024-01-19",
      rating: 5,
      title: "If you don't like clove, you'll be fine",
      body: "They absolutely nailed it with this scent! I'm not a big fan of clove, but it's so subtly blended that it actually enhances the woodsy notes. Plus, this is one of the smoothest butters I've ever tried. A+!!!",
      verified: true
    },
    {
      name: "Jason S.",
      date: "2024-04-16",
      rating: 5,
      title: "Smooth butter",
      body: "Very nice butter. Keeps my beard soft. I got the unscented and it truly is unscented.i know that maybe odd to read but I have another companies unscented that smells like oils and it's kinda annoying smelling them.",
      verified: true
    },
    {
      name: "Tony G.",
      date: "2023-05-23",
      rating: 5,
      title: "Solid Beard Oil",
      body: "Really great beard oil. Doesn’t leave it looking greasy when you apply as recommended for length of beard. Also, what really works well is when you apply into a damp beard. Has worked wonders for me locking in moisture.",
      verified: true
    },
    {
      name: "Erik J.",
      date: "2024-01-30",
      rating: 5,
      title: "Easy to use",
      body: "I'm really happy with the difference this product has made on my beard! It leaves it feeling soft and not greasy at all. I'm a fan of the products from Honor and definitely plan to keep buying more from them.",
      verified: true
    },
    {
      name: "Benjamin A.",
      date: "2024-02-02",
      rating: 5,
      title: "Good consistency and scent",
      body: "This butter is seriously the bomb. The consistency is perfect, and it melts down super easy in your hands. Feels awesome in the beard, and the coffee scent? It's amazing with a little hint of maple vibes too!",
      verified: true
    },
    {
      name: "George J.",
      date: "2023-03-31",
      rating: 5,
      title: "Slow Burn - Recommended by Dan C Bearded",
      body: "I am enjoying the scent a lot & plan on buying more of Honor Initiative's scents.\n\nI also want to commend Honor Initiative to help men's mental health care. That's pretty stand up if you ask me.",
      verified: true
    },
    {
      name: "Dan M.",
      date: "2022-04-04",
      rating: 5,
      title: "Great stuff",
      body: "This feels great in beard. The smell is amazing. I work in construction and have hade people comment on something smells great and I have to reply that's my beard oil. It leaves my beard soft and manageable",
      verified: true
    },
    {
      name: "James K.",
      date: "2022-02-28",
      rating: 5,
      title: "The Scent is only to start....",
      body: "This is my favorite scent of any brand. It pops but not in a in your face pop. It truly is an amazing scent! And I haven't even mentioned feel in beard. Oil + the butter wow! My beard is devoted!",
      verified: true
    },
    {
      name: "Noah H.",
      date: "2023-12-11",
      rating: 5,
      title: "Grooming Magic",
      body: "This beard butter is the real deal for your beard, and it's definitely not greasy. The scent caught my girlfriend's attention, and let's just say her reaction was pretty darn positive.",
      verified: true
    },
    {
      name: "Amber G.",
      date: "2023-01-09",
      rating: 5,
      title: "Sample to subscription!!",
      body: "I ordered a sample size to check it out and looks like I’ll be buying the hubs a subscription. It’s fantastic. Sent is amazing and his beard is super soft! Amazing all around and couldn’t be happier.",
      verified: true
    },
    {
      name: "SERGIO A.",
      date: "2024-04-01",
      rating: 5,
      title: "This is the best!",
      body: "This product is awesome if you're looking to start your hair care routine the right way. It gives your hair a ton of volume and texture, smells amazing, and is just perfect for using every day.",
      verified: true
    },
    {
      name: "Andrew G.",
      date: "2022-03-28",
      rating: 5,
      title: "Best light beard butter on market",
      body: "This butter is amazing. Keeps my beard super soft. I definitely recommend it to anyone who wants a butter that keeps the beard super soft n healthy. My beard loves this products. 5 stars all the way",
      verified: true
    },
    {
      name: "Bobby C.",
      date: "2022-12-25",
      rating: 5,
      title: "Borealis HW Oil Review",
      body: "Borealis smells wonderful! Might be my favorite seasonal fragrance of those I’ve been able to try. The HW oil blend works great for my beard. Thanks for a great product! One of my favorites!",
      verified: true
    }
  ];

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getInitial(name) {
    if (!name) return "?";
    return name.trim().charAt(0).toUpperCase();
  }

function getFirstNameWithInitial(name) {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    // Only one token, e.g. "Rcon89"
    return parts[0];
  }
  const first = parts[0];
  const last = parts[parts.length - 1];
  const lastInitial = last.charAt(0);
  return `${first} ${lastInitial}.`;
}

  function formatDate(iso) {
    const dt = new Date(iso + "T00:00:00");
    if (isNaN(dt.getTime())) return "";
    return dt.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  }

  function renderStarSpansFromValue(value, sizeClass) {
    const v = Math.max(0, Math.min(5, Number(value) || 0));
    const full = Math.floor(v);
    const hasHalf = (v - full) >= 0.5 ? 1 : 0;
    const empty = 5 - full - hasHalf;
    let html = "";

    for (let i = 0; i < full; i++) html += '<span class="hi-star ' + (sizeClass || "") + ' hi-star--full"></span>';
    if (hasHalf) html += '<span class="hi-star ' + (sizeClass || "") + ' hi-star--half"></span>';
    for (let i = 0; i < empty; i++) html += '<span class="hi-star ' + (sizeClass || "") + '"></span>';

    return html;
  }

  function initOne(root) {
    if (!root) return;

    if (root.dataset.hiFeedbackInit === "1") return;
    root.dataset.hiFeedbackInit = "1";

    const listEl = root.querySelector("#hi-feedback-list");
    const prevBtn = root.querySelector("#hi-feedback-prev");
    const nextBtn = root.querySelector("#hi-feedback-next");
    const dotsWrap = root.querySelector("#hi-feedback-dots");

    if (!listEl || !prevBtn || !nextBtn || !dotsWrap) {
      root.dataset.hiFeedbackInit = "0";
      return;
    }

    let currentPage = 1;
    let totalPages = Math.ceil(feedbackData.length / ITEMS_PER_PAGE) || 1;

    function scrollActiveDotIntoView() {
      const active = dotsWrap.querySelector(".hi-feedback__dot.is-active");
      if (!active) return;

      const wrapRect = dotsWrap.getBoundingClientRect();
      const dotRect = active.getBoundingClientRect();

      const leftOverflow = dotRect.left - wrapRect.left;
      const rightOverflow = dotRect.right - wrapRect.right;

      if (leftOverflow < 0) {
        dotsWrap.scrollBy({ left: leftOverflow - 12, behavior: "smooth" });
      } else if (rightOverflow > 0) {
        dotsWrap.scrollBy({ left: rightOverflow + 12, behavior: "smooth" });
      }
    }

    function setActiveDot() {
      const dots = dotsWrap.querySelectorAll(".hi-feedback__dot");
      dots.forEach(function (d) {
        const p = parseInt(d.dataset.page, 10);
        const isActive = p === currentPage;
        d.classList.toggle("is-active", isActive);
        if (isActive) d.setAttribute("aria-current", "page");
        else d.removeAttribute("aria-current");
      });
    }

    function renderPage(page) {
      totalPages = Math.ceil(feedbackData.length / ITEMS_PER_PAGE) || 1;
      currentPage = Math.min(Math.max(page, 1), totalPages);

      const start = (currentPage - 1) * ITEMS_PER_PAGE;
      const slice = feedbackData.slice(start, start + ITEMS_PER_PAGE);

      listEl.innerHTML = slice.map(function (r) {
        const initial = getInitial(r.name);
        const firstName = getFirstNameWithInitial(r.name);
        const stars = renderStarSpansFromValue(r.rating, "hi-star--small");
        const date = formatDate(r.date);

        const rawTitle = (r.title || "").trim();
        const safeTitle = (rawTitle && rawTitle.toLowerCase() !== "nan") ? rawTitle : "";

        return (
          '<article class="hi-feedback-item">' +
            '<div class="hi-feedback-item__avatar">' + escapeHtml(initial) + '</div>' +
            '<div class="hi-feedback-item__meta">' +
              '<div class="hi-feedback-item__name-row">' +
                '<span class="hi-feedback-item__name">' + escapeHtml(firstName) + '</span>' +
                (r.verified
                  ? '<span class="hi-feedback-item__verified">' +
                      '<span class="hi-feedback-item__verified-text">Verified by</span>' +
                      '<img src="https://cdn.shopify.com/s/files/1/0259/1821/0095/files/Shop_Logo.png?v=1771538305" alt="Shop" class="hi-feedback-item__verified-logo" />' +
                    '</span>'
                  : ''
                ) +
              '</div>' +
            '</div>' +
            '<div class="hi-feedback-item__content">' +
              (date ? '<div class="hi-feedback-item__dateLine">' + escapeHtml(date) + '</div>' : '') +
              '<div class="hi-feedback-item__stars">' + stars + '</div>' +
              '<div class="hi-feedback-item__body">' +
  (safeTitle ? '<p class="hi-feedback-item__title">' + escapeHtml(safeTitle) + '</p>' : '') +
  '<p>' + escapeHtml(r.body) + '</p>' +
  (r.image ? '<div class="hi-feedback-item__image"><img src="' + escapeHtml(r.image) + '" alt="Review image" /></div>' : '') +
'</div>' +
            '</div>' +
          '</article>'
        );
      }).join("");

      prevBtn.disabled = currentPage === 1;
      nextBtn.disabled = currentPage >= totalPages;

      setActiveDot();
      scrollActiveDotIntoView();
    }

    function goToPage(page) {
      // Preserve exact scroll position
      const y = window.pageYOffset;

      renderPage(page);

      // Restore scroll after DOM reflow
      requestAnimationFrame(function () {
        window.scrollTo(0, y);
        requestAnimationFrame(function () {
          window.scrollTo(0, y);
        });
      });
    }

    function buildDotsOnce() {
      totalPages = Math.ceil(feedbackData.length / ITEMS_PER_PAGE) || 1;
      dotsWrap.innerHTML = "";

      for (let i = 1; i <= totalPages; i++) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "hi-feedback__dot" + (i === currentPage ? " is-active" : "");
        dot.dataset.page = String(i);
        dot.setAttribute("aria-label", "Go to page " + i);
        if (i === currentPage) dot.setAttribute("aria-current", "page");

        // Direct binding (more reliable than delegation in Shopify themes)
        dot.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const p = parseInt(dot.dataset.page, 10);
          if (!Number.isFinite(p)) return;
          goToPage(p);
          dot.blur();
        });

        // Prevent focus scroll quirks
        dot.addEventListener("mousedown", function (e) { e.preventDefault(); });

        dotsWrap.appendChild(dot);
      }

      scrollActiveDotIntoView();
    }

    // Buttons
    prevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentPage > 1) goToPage(currentPage - 1);
      prevBtn.blur();
    });

    nextBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentPage < totalPages) goToPage(currentPage + 1);
      nextBtn.blur();
    });

    prevBtn.addEventListener("mousedown", function (e) { e.preventDefault(); });
    nextBtn.addEventListener("mousedown", function (e) { e.preventDefault(); });

    // Init
    buildDotsOnce();
    renderPage(1);
  }

  function bootWithRetry(triesLeft) {
    const roots = document.querySelectorAll("#hi-feedback-section");
    if (roots.length) {
      roots.forEach(initOne);
      return;
    }

    if (triesLeft > 0) {
      setTimeout(function () { bootWithRetry(triesLeft - 1); }, 200);
    }
  }

  function boot() {
    bootWithRetry(15);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();